<template>
    <div class="box_big">
      <div class="nav">
        <button class="btn" @click="bk()">< 返回</button>
        <span class="el-dropdown-link c1">单品销售数量</span>
      </div>
      <el-table
          :data="tableData"
          style="width: 100%;"
          :header-cell-style="{background:'#cac7c7'}">
        <el-table-column
                align="center"
            label="商品"
            min-width="100%" >
          <template slot-scope="scope">
            <span style="color: #A3A8B0;font-size: 12px">{{scope.row.goods_name}}</span>
          </template>
        </el-table-column>
        <el-table-column
                align="center"
            label="考核指标"
            min-width="100%">
          <template slot-scope="scope">
            <span style="color: #A3A8B0;font-size: 12px">{{scope.row.actual_value}}</span>
          </template>
        </el-table-column>
        <el-table-column
                align="center"
            label="完成指标"
            min-width="100%">
          <template slot-scope="scope">
            <span style="color: #A3A8B0;font-size: 12px">{{scope.row.target_value}}</span>
          </template>
        </el-table-column>
        <el-table-column
                align="center"
            label="完成率"
            min-width="100%">
          <template slot-scope="scope">
            <span style="color: #7ED321;font-size: 13px">{{scope.row.rate}}%</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
</template>

<script>
export default {
  name: "login10",
  data(){
    return{
      tableData:[],
    }
  },
  methods:{
    bk(){
      this.$router.push({path:'/Personal'})
    },

  },
 created () {
    this.tableData=[]
    this.tableData = this.$route.query.skuArr
   console.log(this.tableData)
 }
}
</script>

<style>
  button{
    border: none;
    color: orange;
    background-color: white;
    margin: 10px 5px;
  }
  .nav{
    width: 100%;
    height: 50px;
    background-color: white;
  }
  .c1{
    margin-left: 80px;
    margin-top: 15px;
    font-size: 18px;
    position: absolute;
  }
</style>



// WEBPACK FOOTER //
// src/pages/gkReport/Prout.vue